import { createAction, props } from '@ngrx/store';

const UPDATE_APP_MODEL = '[Application DataModel] Update Application Datamodel';
const UPDATE_VIEWER_INFO = '[Application DataModel] Update Viewer Info';
const DELETE_VIEWER_INFO = '[Application DataModel] Delete Viewer Info';
const UPDATE_DRAG_DROP = '[Application DataModel] Drag and Drop';
const UPDATE_APP_MODEL_SUCC = '[Application DataModel] Update Table data Success';
const UPDATE_APP_MODEL_FAIL = '[Application DataModel] Update Table data Failure';
const DRAG_DROP_FAIL = '[Application DataModel] Drag Drop Failed';
const DRAG_DROP_SUCC = '[Application DataModel] Drag Drop Success';
const UPDATE_PAR_TBL = '[Application DataModel] Update Parent Table';
const PAR_TBL_FAIL = '[Application DataModel] Update Pearent Table Failed';
const PAR_TBL_SUCC = '[Application DataModel] Update Parent Table Success';
const UPDATE_TBL_TYPE = '[Application DataModel] Update Table Type';
const TBL_TYPE_FAIL = '[Application DataModel] Update Table Type Failed';
const TBL_TYPE_SUCC = '[Application DataModel] Update Table Type Success';
const SET_RUNTIME_WORKFLOW_STATUS_FIELD = '[Application DataModel] Set Runtime Workflow Status Field';

const updateAppDM = createAction(UPDATE_APP_MODEL, props<{ apiConstants: any; appDMData: any }>());

const updateAppDMSuccess = createAction(UPDATE_APP_MODEL_SUCC, props<{ appDMSuccData: any }>());

const updateAppDMFailure = createAction(UPDATE_APP_MODEL_FAIL, props<{ appDMFailData: any }>());

const updateViewerInfo = createAction(UPDATE_VIEWER_INFO, props<{ vwApiConstants: any; userData: any }>());

const deleteViewerInfo = createAction(DELETE_VIEWER_INFO, props<{ delApiConstants: any; userData: any }>());

const updateDragDrop = createAction(UPDATE_DRAG_DROP, props<{ dropApiConstants: any; data: any }>());

const dragDropFailure = createAction(DRAG_DROP_FAIL, props<{ dropFailed: any }>());

const dragDropSuccess = createAction(DRAG_DROP_SUCC, props<{ dropSucc: any }>());

const updParentTbl = createAction(UPDATE_PAR_TBL, props<{ parApiConstants; parTblData: any }>());

const parTblFailure = createAction(PAR_TBL_FAIL, props<{ parTblFailed: any }>());

const parTblSuccess = createAction(PAR_TBL_SUCC, props<{ parTblSucc: any }>());

const updTableType = createAction(UPDATE_TBL_TYPE, props<{ tblTypeApiConstants; payload: any }>());

const tableTypeFailure = createAction(TBL_TYPE_FAIL, props<{ tblTypeFailed: any }>());

const tableTypeSuccess = createAction(TBL_TYPE_SUCC, props<{ tblTypeSucc: any }>());

const setRuntimeWorkflowStatusField = createAction(SET_RUNTIME_WORKFLOW_STATUS_FIELD, props<{ runtimeWorkflowStatusField: any }>());

export {
  updateAppDM,
  updateViewerInfo,
  deleteViewerInfo,
  updateDragDrop,
  updateAppDMSuccess,
  dragDropFailure,
  dragDropSuccess,
  updateAppDMFailure,
  updParentTbl,
  parTblFailure,
  parTblSuccess,
  updTableType,
  tableTypeFailure,
  tableTypeSuccess,
  setRuntimeWorkflowStatusField
};
